module.exports = __webpack_public_path__ + "assets/static/media/app.83ca6c70.scss";